import { Box, Text } from '@chakra-ui/react';
import AvatarsGroupMy from 'components/AvatarsGroupMy';

const MembersCell = ({ data }: { data?: Array<string> }) => (
    <Box>
        <AvatarsGroupMy data={[]} />
        <Text fontSize="16px" fontWeight={500}>
            {data.length}
        </Text>
    </Box>
);

export default MembersCell;
